import { render, staticRenderFns } from "./ItemsDetailsStep.vue?vue&type=template&id=97d7ad6c&scoped=true"
import script from "./ItemsDetailsStep.vue?vue&type=script&lang=js"
export * from "./ItemsDetailsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d7ad6c",
  null
  
)

export default component.exports